module.exports = __webpack_public_path__ + "static/media/One_Click_One_Solution.08fa541a.svg";